import React from 'react';
import {
  HashRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import AboutPage from './components/aboutPage';
import DropDownMenu from './components/dropDownMenu';
import LandingPage from './components/landingPage';
import RecognitionsPage from './components/recognitionsPage';
import WorkExperiencePage from './components/workExpPage';
import SkillSetFooter from './components/skillSetFooter';
import ContactPage from './components/contactPage';
import './App.css';
import BackgroundVideo from "./images/bg_compressed.mp4";

function App() {
  return (
    <div className="container-fluid h-100">
      <Router>
      <video autoPlay muted loop className="BackgroundVideo">
        <source src={BackgroundVideo} type="video/mp4"/>
      </video>
      <div className="row">
        <div className="col headerBar">
          <DropDownMenu />
        </div>
      </div>
      <div className="row">
        <div className="col mainView">
        
          <Switch>
            <Route path="/recognitions">
              <RecognitionsPage/>
            </Route>
            <Route path="/about">
              <AboutPage />
            </Route>
            <Route path="/work-exp">
              <WorkExperiencePage />
            </Route>
            <Route path="/social">
              <ContactPage/>
            </Route>
            <Route path="/">
              <LandingPage />
            </Route>
          </Switch>
        
        </div>
      </div>
      <div className="row skillSet-footer">
        <SkillSetFooter />
      </div>
      </Router>
    </div>
  );
}

export default App;
